<template>
  <div class="invoice-detail">
    <div v-if="Object.keys(details).length > 0">
      <Row v-if="details.coverFileId">
        <Col span="3">
          <z-panelimg :del="false" :src="ossPrefix + details.invoiceFile.key"></z-panelimg>
        </Col>
      </Row>
      <Row v-if="details.coverFile">
        <Col span="3">
          <z-panelimg :del="false" :src="ossPrefix + details.coverFile.key"></z-panelimg>
        </Col>
      </Row>
      <Row :gutter="30">
        <Col span="5" v-if="isShow('type')">发票类型：{{invoiceType(details.type)}}</Col>
        <Col span="7" v-if="isShow('title')">发票抬头：{{details.title}}</Col>
        <Col span="10" v-if="isShow('identityCode')">纳税人识别号：{{details.identityCode}}</Col>
      </Row>
      <Row :gutter="30" v-if="isShow('registerTel') || isShow('registerAddress')">
        <Col span="5" v-if="isShow('registerTel')">注册电话：{{details.registerTel}}</Col>
        <Col span="10" v-if="isShow('registerAddress')">注册地址：{{details.registerAddress}}</Col>
      </Row>
      <Row :gutter="30" v-if="isShow('bankInfo') || isShow('bankInfo')">
        <Col span="5" v-if="isShow('bankInfo')">开户银行：{{details.bankInfo}}</Col>
        <Col span="10" v-if="isShow('bankAccount')">银行账户：{{details.bankAccount}}</Col>
      </Row>
      <Row :gutter="30">
        <Col span="5">发票内容：家居产品</Col>
        <Col span="5">发票金额：{{details.invoicePrice | currency('¥', '2')}}(订单金额)</Col>
      </Row>
      <Row :gutter="30">
        <Col span="5">收票人：{{details.receiverName}}</Col>
        <Col span="5">发票人手机：{{details.receiverPhone}}</Col>
      </Row>
      <Row :gutter="30">
        <Col span="20">收票地址：{{details.receiverAddress}}</Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    details: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  methods: {
    isShow(pro) {
      if (this.details[pro]) {
        return true;
      } else {
        return false;
      }
    },
    //发票类型
    invoiceType(type) {
      switch (type) {
        case 0 || 1:
          return "纸质普通发票";
          break;
        case 2:
          return "增值税专用发票";
          break;
        default:
          return "纸质普通发票";
      }
    }
  }
};
</script>

<style lang="scss">
.invoice-detail {
  margin-top: 30px;
  .ivu-row {
    margin-top: 15px;
    &:first-child {
      margin-top: 0px;
    }
    .ivu-col {
      color: #666;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}
</style>


